import "./InnerBanner.css";

const InnerBanner = ({ title, bgImage }) => {
  return (
    <div
      className="inner-banner"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="inner-overlay">
        <div className="inner-content">
          <h1>{title}</h1>
        </div>
      </div>
    </div>
  );
};

export default InnerBanner;